<template>
    <van-popup v-model="popupShow" position="bottom" :lazy-render="false">
        <div class="page bg-fff page-flex">
            <titleBar :leftEle="leftEle" :rightText="rightText"></titleBar>
            <div class="map allmap" id="allmap">

            </div>
            <div class="search-input-box">
                <div class="search-input">
                    <div class="alifont icon-xpsousuo"></div>
                    <input type="search" placeholder="请输入要搜索地址的地址" v-model="keyword" @keyup.13="autoInput">
                </div>
            </div>
            <div class="flex1 address-list pd-025">
                <div class="flex-center pd-250 bd-bot" v-for="(item,$index) in searchList" :key="$index" @click="chooseAddress(item)">
                    <div class="flex1 ofh">
                        <div class="fs-32 color-333">{{item.name}}</div>
                        <div class="fs-24 color-999 text-el mt-10">{{item.address}}</div>
                    </div>
                    <div class="alifont icon-xuanzhong1 color-main ml-15" style="font-size: .48rem" v-show="locationId == item.id"></div>
                </div>
            </div>
        </div>

        <van-popup v-model="loading" :style="{ background:'none',overflow:'hidden'}">
            <van-loading size="40px" color="#fff" vertical><span class="color-fff">搜索中...</span></van-loading>
        </van-popup>
    </van-popup>
</template>

<script>
    import titleBar from "@/components/titleBar/baseTitleBar"
    export default {
        name: "chooseAddress",
        components:{titleBar},
        props: {
            lng: {
                type: Number,
                default: ''
            },
            lat:{
                type: Number,
                default: ''
            }
        },
        data(){
            return{
                rightText:{
                    color:'#333',
                    fontSize:'.28rem',
                    text:'确定',
                    method: this.sureFun
                },
                leftEle:{
                    iconName:'icon-back',
                    color:'#333',
                    fontSize:'.36rem',
                    method: this.back
                },
                popupShow:false,
                map: null,
                localSearch: null,
                marker:null,
                placeSearch:null,
                point:null,
                address:'',
                locationId:'',
                keyword:'',
                searchList:[],
                loading:false,
                placeSearchPluginFinish:false
            }
        },
        methods:{
            //初始化地图
            initMap(){
                let _this = this;
                _this.map = new AMap.Map('allmap', {
                    resizeEnable: true, //是否监控地图容器尺寸变化
                    zoom:11, //初始化地图层级
                    center: [116.397428, 39.90923] //初始化地图中心点
                });
                AMap.service(['AMap.PlaceSearch'],function(){
                    _this.placeSearchPluginFinish = true;
                    _this.placeSearch = new AMap.PlaceSearch( {
                        city: '全国'
                    });
                });


            },
            // 获取搜索信息
            autoInput(){
                var keywords = this.keyword;
                if(!keywords){
                    return
                }
                let _this = this;
                if(!this.placeSearchPluginFinish){
                    this.$toast("搜索地址插件加载中，请稍后重试");
                    return
                }
                this.loading = true;
                this.placeSearch.search(keywords, function(status, result) {
                    _this.loading = false;
                    if(result.poiList.pois.length != 0 ){
                        _this.searchList = result.poiList.pois
                    }
                })
            },
            //选择地址
            chooseAddress(data){
                let point = data.location;
                this.point = point;
                this.address = {address: data.address}
                this.locationId = data.id;
                this.drawMarker(point)
            },
            drawMarker(point){
                if(this.marker){
                    this.map.remove(this.marker);
                }
                this.marker = new AMap.Marker({
                    position: new AMap.LngLat(point.lng,point.lat),
                });
                this.map.add(this.marker)                                 //添加标注
                this.map.setZoomAndCenter(16, [point.lng,point.lat]);     //地图中心点和缩放级别
            },
            back(){
                this.popupShow = false;
            },

            sureFun(){
                if(!this.point){
                    this.$toast("请选择地址");
                    return
                }
                let data =  Object.assign({}, this.point, this.address)
                this.$emit('sure', data)
                this.back();
            },
            getMyLocation(){
                let _this = this;
                setTimeout(function(){
                    try {
                        u.native.getLocation(function (respon) {
                            console.log('respon:',respon)
                            if (respon) {
                                let obj = JSON.parse(respon);
                                if (obj.code == 200) {
                                    _this.point = obj.data;
                                    _this.drawMarker(_this.point)
                                }else{
                                    _this.$toast("获取定位失败，请输入地址搜索");
                                    return
                                }
                            }
                        })
                    } catch (e) {
                        _this.$toast("请输入地址搜索");
                    }
                },10)
            }
        },
        watch:{
            popupShow(val){
                if(val && this.lng && this.lat){
                    this.point = {lng:this.lng,lat:this.lat}
                    this.drawMarker(this.point)
                }else if(val && !this.lng && !this.lat){
                    this.getMyLocation();
                }
            }
        },
        mounted(){
            this.initMap();
        }
    }
</script>

<style scoped lang="scss">
    .map{
        height: 4.4rem;
        width: 100%;
    }
    .search-input-box{
        margin-top: .1rem;
        padding: .1rem .25rem;
        .search-input{
            padding: .12rem;
            display: flex;
            align-content: center;
            background: #F5F5F5;
            border-radius: .12rem;
        }
        .alifont{
            font-size: .48rem;
            color: #666;
            margin-right: .12rem;
        }
        input{
            flex: 1;
            border: none;
            background: none;
            outline: none;
            font-size: .28rem;
            line-height: .4rem;
            padding: 0;
            color: #666;
        }
    }
    .address-list{
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        height: 100%;
    }
</style>




// WEBPACK FOOTER //
// chooseAddress.vue?7d00669e